export default __webpack_public_path__ + "media/Beverage-Other.170b1e8c.png";